import { Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";
import PageRoutes from "../utils/routes";
import { Spin } from "antd";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { firmAuth, personnelAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error("Failed to refresh token:", err);
        // When refresh fails, we should redirect to login
        navigate(PageRoutes.authHomePage, { replace: true });
      } finally {
        if (mounted) setIsLoading(false);
      }
    };

    // We should also check if the access tokens are expired
    const isTokenExpired = (token) => {
      if (!token) return true;
      // Add your token expiration check logic here
      // For example, if your tokens contain an exp claim:
      // const decoded = jwt_decode(token);
      // return decoded.exp * 1000 < Date.now();
      return false;
    };

    const shouldVerify =
      // Check for refresh token with no access token
      (firmAuth?.refreshToken && !firmAuth?.accessToken) ||
      (personnelAuth?.refreshToken && !personnelAuth?.accessToken) ||
      // Or check for expired access tokens
      (firmAuth?.accessToken && isTokenExpired(firmAuth.accessToken)) ||
      (personnelAuth?.accessToken && isTokenExpired(personnelAuth.accessToken));

    shouldVerify ? verifyRefreshToken() : setIsLoading(false);

    return () => {
      mounted = false;
    };
  }, [refresh, firmAuth, personnelAuth, navigate]);

  if (isLoading) {
    return <Spin spinning={true} fullscreen></Spin>;
  }

  return <Outlet />;
};

export default PersistLogin;
